import { LoginForm } from '../components/LoginForm';
import { usePageTitle } from '@/hooks/usePageTitle';

export function LoginPage() {
  usePageTitle('Sign In');
  // Cardless (86d3cff1t) — the form sits directly on the page surface for a
  // cleaner, single-column look.
  return (
    <div className="w-full">
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-foreground">Sign in</h2>
        <p className="mt-1 text-sm text-muted-foreground">
          Enter your credentials to access your account
        </p>
      </div>
      <LoginForm />
    </div>
  );
}
